import * as Sentry from '@sentry/nextjs';
import Router from 'next/router';
import { UserApi } from '@api';
import {
  setAuthToken,
  getAuthToken,
  clearAuthToken,
  parsedToken,
} from '@dotone/react-ui-core/utils';
import { refreshBeforePrompt } from '@dotone/react-ui-core/constants';
import { authTypes as actionTypes } from './types';

export const authenticate = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.LOADING,
  });

  const { redirectTo, type, ...data } = params;

  const api = type === 'network' ? UserApi.authenticate : UserApi.authenticateMember;

  api(data)
    .then((response) => {
      if (response.token) {
        setAuthToken(response.token, response.expiresIn);
        dispatch({
          type: actionTypes.SUCCESS,
          payload: response,
          redirectTo,
        });
      } else if (response.tfaSent) {
        dispatch({
          type: actionTypes.TFA_SENT,
          payload: response,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.FAILURE,
        redirectTo,
        ...error.data,
      });
    });
};

export const deauthenticate = () => (dispatch) => {
  clearAuthToken();
  dispatch({
    type: actionTypes.DEAUTH,
  });
  Sentry.setUser(null);
};

export const authenticateViaToken = (params, redirectTo) => (dispatch) => {
  dispatch(deauthenticate());

  dispatch({
    type: actionTypes.LOADING,
  });

  UserApi.authenticateViaToken(params)
    .then((response) => {
      setAuthToken(response.token, response.expiresIn);
      dispatch({
        type: actionTypes.SUCCESS,
        payload: response,
        redirectTo,
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.FAILURE,
        redirectTo,
        ...error.data,
      });
    });
};

export const reauthenticate =
  (params = {}) =>
  (dispatch) => {
    const token = getAuthToken('network');
    const { expiresIn } = parsedToken();
    if (token) {
      if (expiresIn < refreshBeforePrompt) {
        UserApi.refreshToken(params)
          .then((response) => {
            setAuthToken(response.token, response.expiresIn);
            dispatch({
              type: actionTypes.REAUTH,
              token: response.token,
              ...params,
            });
          })
          .catch(() => {
            dispatch(deauthenticate());
          });
      } else {
        dispatch({
          type: actionTypes.REAUTH,
          token,
          ...params,
        });
      }
    } else {
      dispatch({
        type: actionTypes.REAUTH,
        ...params,
      });
      Router.push('/advertisers/login');
    }
  };
